export var COMMON_TRANSLATIONS = {
    commons: {
        continue: 'Continuar',
        cancel: 'Cancelar',
        edit: 'Editar informaciones',
        save: 'Guardar',
        digits: 'dígitos',
        characters: 'caracteres',
        fields: {
            errors: {
                required: 'Campo requerido',
                email: 'Correo electrónico inválido',
                phone: 'Teléfono inválido',
                minLenght: 'Debe contener mínimo {{min}} {{type}}',
                maxLenght: 'Debe contener máximo {{max}} {{type}}',
                minMaxLength: 'Debe contener entre {{min}} y {{max}} {{type}}',
                length: 'Debe contener exactamente {{length}} {{type}}',
                onlyDigits: 'Debe contener solo números',
                invalidFormat: 'Formato inválido',
            },
        },
        buttons: {
            next: 'Próximo',
            previous: 'Anterior',
            accept: 'Aceptar',
            cancel: 'Cancelar',
        },
        files: {
            dropLabel: 'Suelta el archivo aquí',
            label: {
                default: 'Arrastra el archivo acá o',
                generating: 'Generando menú con IA...',
                success: 'Menú generado',
                error: 'Error de generación',
            },
            description: {
                generating: 'Este proceso puede tardar hasta 5 minutos.',
                success: 'Revísalo para que termines de configurarlo.',
            },
            button: {
                replace: 'Reemplazar',
                select: 'Seleccionar',
            },
            rules: {
                format: 'Formato',
                size: 'Tamaño',
            },
            errors: {
                noSupport: 'Archivo no soportado!',
                encrypted: 'Archivo encriptado',
                format: 'Formato del archivo no permitido',
                maxSize: 'Tamaño del archivo máximo excedido',
                merge: 'Error al unir los archivos',
            },
        },
        errors: {
            communication: 'Error de comunicación, intenta de nuevo',
        },
    },
};
